import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "../../../components/Editor";
export default {
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      form: {
        id: "",
        flag: "",
        language: "",
        desc: ""
      },
      iconfileList: [],
      picfileList: [],
      rules: {
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        desc: [{
          required: true,
          message: "请输入内容",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.form = {
                    id: data.id,
                    flag: data.flag,
                    language: data.language,
                    desc: data.desc
                  };
                }

                _this.$refs.newPopover.open();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearData: function clearData(id) {
      this.form = {
        id: id,
        flag: this.form.flag,
        language: "",
        desc: ""
      };
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.form.id ? 'updWebDescriptions' : 'addWebDescriptions';

          _this2.$api[reqFn](_this2.form).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.$refs.newPopover.hide();

              _this2.$emit('change');
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};